const Item = ({ link }) => {
  return (
    <li>
      <a href='#'>
        {link}
      </a>
    </li>
  );
}
 
export default Item;